import React from "react";
import { Icon, Dropdown, DropdownToggle, DropdownMenu, LinkList, LinkListItem } from 'design-react-kit'

export default function SignInButton() {

    function handleLogin() {
        // Reindirizziamo l'utente direttamente al nostro BFF
        // Usiamo window.location.assign per cambiare pagina
        const isDebug = process.env.NODE_ENV === 'development';
        const bffUrl = isDebug ? 'http://localhost:3001' : '/api';

        window.location.assign(bffUrl + "/login");
    }

    function handleSpidLogin() {
        //location.href = process.env.SPID_URL + "oauth2/authorize?agEntityId=" + process.env.AG_ENTITY_ID + "&comEntityId=" + process.env.COM_ENTITY_ID + "&isAuthSilfi=yes&client_id=" + process.env.SPID_CLIENT_ID + "&redirect_uri=" + process.env.LOGIN_REDIRECT_URI + "authorized&response_type=code&scope=openid";
        const isDebug = process.env.NODE_ENV === 'development';
        const bffUrl = isDebug ? 'http://localhost:3001' : '/api';

        window.location.href = `${bffUrl}/login-spid`;
    }

    function handleIstruzioneLogin() {
        location.href = process.env.URL_ISTRUZIONE;
    }

    return (
        <Dropdown className="me-3">
            <DropdownToggle caret color="primary">
                <Icon className='me-2' color='white' icon='it-user' size='xs' />
                Accedi
            </DropdownToggle>
            <DropdownMenu>
                <LinkList>
                    <LinkListItem inDropdown href='#'>
                        <span onClick={() => handleLogin()}>Accedi con SSO</span>
                    </LinkListItem>
                    <LinkListItem inDropdown href='#'>
                        <span onClick={() => handleSpidLogin()}>Accedi con SPID</span>
                    </LinkListItem>
                    <LinkListItem inDropdown href='#'>
                        <span onClick={() => handleIstruzioneLogin()}>Accesso Istruzione</span>
                    </LinkListItem>
                </LinkList>
            </DropdownMenu>
        </Dropdown>
    )
}